// client/components/Übersicht/LeitstandMobileList.jsx
import React from "react";
import AppButton from "../ui/AppButton.jsx";
import { cn } from "../../utils/themeClasses.js";

const cellCls = s => {
  const v = Number(s);
  if (v === 2) return "bg-green-500/70";
  if (v === 1) return "bg-amber-400/80";
  return "bg-rose-500/70";
};

/**
 * Kompakte Projektliste für Mobile — Alternative zur breiten LeitstandMatrix.
 * Nur unter md sichtbar (Parent steuert hidden md:block / md:hidden).
 */
export default function LeitstandMobileList({ columns = [], rows = [], onRowClick }) {
  if (!rows.length) {
    return (
      <div className="p-8 text-center rounded-xl border border-white/10 text-blue-200/70">
        Keine Daten gefunden.
      </div>
    );
  }

  return (
    <ul className="space-y-3 min-w-0">
      {rows.map(r => (
        <li key={r.id ?? r.name}>
          <AppButton
            type="button"
            variant="ghost"
            onClick={() => onRowClick?.(r)}
            className={cn(
              "leitstand-card-hit w-full !h-auto min-h-[44px] !justify-start text-left rounded-xl border border-white/10 bg-white/[0.03] px-3 py-3",
            )}
          >
            <div className="w-full min-w-0 space-y-2">
              <div className="font-medium text-blue-100 truncate">{r.name}</div>
              {r.next_label ? (
                <div className="text-[11px] text-blue-200/65 truncate">Next: {r.next_label}</div>
              ) : null}
              <div className="flex flex-wrap gap-1">
                {columns.map((label, i) => {
                  const val = Number(r.cells?.[i] ?? 0);
                  return (
                    <span
                      key={label}
                      className={cn(
                        "inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] text-blue-100/90 border border-white/10",
                      )}
                      title={`${label}: ${val === 2 ? "erledigt" : val === 1 ? "in Arbeit" : "offen"}`}
                    >
                      <span className={cn("w-2 h-2 rounded-sm shrink-0", cellCls(val))} aria-hidden />
                      <span className="truncate max-w-[4.5rem]">{label}</span>
                    </span>
                  );
                })}
              </div>
            </div>
          </AppButton>
        </li>
      ))}
    </ul>
  );
}
